import type { ComponentType } from 'react';

// Re-export from the main zodiac module
export type { ZodiacSign } from '../zodiac';
export { getZodiacSignFromDate, ZODIAC_SIGNS_DATA } from '../zodiac';

// Import for local use
import { getZodiacSignFromDate, ZODIAC_SIGNS_DATA, type ZodiacSign } from '../zodiac';

// Additional domain-specific zodiac utilities
export const getZodiacIcon = (
  _sign: ZodiacSign | string
): ComponentType<{ className?: string }> | null => {
  // This function should be implemented in the web app layer
  // where the UI components are available
  // For now, return null to avoid circular dependencies
  return null;
};

export const getZodiacData = (sign: ZodiacSign | string) => {
  return ZODIAC_SIGNS_DATA.find((s) => s.name === sign) || null;
};

// Zodiac sign validation
export const isValidZodiacSign = (sign: string): sign is ZodiacSign => {
  return ZODIAC_SIGNS_DATA.some((z) => z.name === sign);
};

// Get zodiac sign from birth date (wrapper for consistency)
export const getZodiacSignFromBirthDate = (dateString: string): ZodiacSign | null => {
  return getZodiacSignFromDate(dateString);
};
